// extracted by mini-css-extract-plugin
export default {"button":"styles_button__cLVM3","disabled":"styles_disabled__GZrd+","secondary":"styles_secondary__4LlWI","left":"styles_left__hbDpt","right":"styles_right__s2jc9"};